'use client';

import { createFileRoute, Navigate } from '@tanstack/react-router';

import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/incidents/dashboard')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.incidentDashboard'),
  }),
  component: () => <Navigate to="/analytics" />,
});
